import { render, staticRenderFns } from "./BankAuthLett.vue?vue&type=template&id=d533cbf0&scoped=true&"
import script from "./BankAuthLett.vue?vue&type=script&lang=js&"
export * from "./BankAuthLett.vue?vue&type=script&lang=js&"
import style0 from "./BankAuthLett.vue?vue&type=style&index=0&id=d533cbf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d533cbf0",
  null
  
)

export default component.exports